import { eventbus } from "utils/eventbus";

export const resetAllEventChannel = eventbus<{
  onResetAll: () => void;
}>();
